import { render, staticRenderFns } from "./WidgetMorphology.vue?vue&type=template&id=f8900a56&"
import script from "./WidgetMorphology.vue?vue&type=script&lang=js&"
export * from "./WidgetMorphology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetMorphology.vue"
export default component.exports